import { Stack, Switch, Typography } from '@mui/material';
import useStyles from '../../hooks/useStyles';
import switchStyle from './styles/switchStyle';

function CustomSwitch(props) {
  const {
    name, label, value, onChange, disabled = false,
  } = props;

  const classes = useStyles(switchStyle)();

  return (
    <Stack className={`${classes.default} ${disabled ? classes.disabled : classes.enabled}`}>
      <Typography variant="subtitle1" fontSize="14px">{label}</Typography>
      <Switch
        color={disabled ? 'default' : 'primary'}
        {...(name && { name })}
        disabled={disabled}
        onChange={onChange}
        checked={value}
      />
    </Stack>
  );
}

export default CustomSwitch;
